<!--
 * @Author: Yuan Cong <email: wso2848303@163.com> <tel: 15821618224>
 * @Date: 2021-01-05 17:24:55
 * @LastEditors Cong Yuan wso2848303@163.com
 * @LastEditTime 2025-06-05 11:17:03
 * @Description: 弹窗组件
 * @FilePath: /hsylc2021/src/components/Dialog/index.vue
-->
<template>
  <Modal :overlay="overlay" :clickOverlayClose="clickOverlayClose" @close="close" :class="{footer: footer}">
    <div class="component-dialog" :class="computedClass">
      <Close className="i-close" v-if="iClose" @click="close" />
      <p class="dialog-title bold h2 color-gray-1">{{ title }}</p>
      <div class="dialog-content color-gray-2 text1">
        <p class="content-text" v-html="content"></p>
        <slot name="content"></slot>
      </div>
      <slot></slot>
      <slot name="footer"></slot>
    </div>
  </Modal>
</template>
<script>
import Modal from '../Modal';
/**
 * 弹窗组件
 * @module Dialog
 */
export default {
  name: 'Dialog',
  /**
   * @prop {Component} Modal 遮罩组件
   */
  components: {
    Modal,
    Close: () => import('../icons/Close')
  },
  /**
   * @prop {Boolean} overlay 是否有非透明遮罩 默认true
   * @prop {Boolean} clickOverlayClose 是否点击遮罩触发close事件 默认true
   * @prop {String} size 弹窗大小 normal-375宽度 默认normal
   * @prop {String} title 弹窗抬头
   * @prop {String} content 弹窗内容
   * @prop {Boolean} iClose 是否展示关闭按钮 默认true
   */
  props: {
    overlay: {
      type: Boolean,
      default: true
    },
    clickOverlayClose: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      default: 'normal'
    },
    title: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ''
    },
    iClose: {
      type: Boolean,
      default: true
    },
    footer: {
      type: Boolean,
      default: false
    }
  },
  /**
   * @prop {Object} computedClass 计算class
   */
  computed: {
    computedClass() {
      let ret = {};
      ret[`size-${this.size}`] = true;
      if (this.footer) {
        ret.footer = true;
      }
      return ret;
    }
  },
  methods: {
    /**
     * @event close 暴漏close事件
     */
    /**
     * @description 关闭事件
     * @function close
     */
    close: function() {
      this.$emit('close');
    }
  }
};
</script>
<style lang="less" scoped src="./index.less"></style>
